module.exports = {"schools_search_bar":{"type_ecole":["Type d'école","School type"],"programme":["Programme","Programme"],"diplome":["Diplôme","Diploma"],"item_all":["Tous","All"],"button_search_title":["Rechercher","Search"],"button_search_title_mobile":["Trouver une école","Find a school"]}}


//////////////////
// WEBPACK FOOTER
// ./src/features/Schools/translations/translations_schoolssearchbar.json
// module id = 545
// module chunks = 0